import {observer} from "mobx-react"
import {Page, PageContentTitle} from "../../ui"
import {cmsDetailStore} from "../../../store"
import {CmsRulesOverviewPage} from "./CmsRulesOverviewPage";
import {useNavigate} from "react-router";
import {CmsCustomerDetail} from "./CmsCustomerDetail";
import {CmsRuleCreatePage} from "./CmsRuleCreatePage";
import {CmsRuleDetailPage} from "./CmsRuleDetailPage";
import {CmsConfigurationPage} from "./configuration/";

export type CmsTabType = 'scan-document-rules' | 'scan-document-rule-create' | 'scan-document-rule-detail' | 'configuration'

interface CmsDetailPageProps {
    tab?: CmsTabType
}

const CmsDetailPage = observer(function CmsDetailPage({
                                                          tab
                                                      }: CmsDetailPageProps) {
    const {
        name,
        customerNumber
    } = cmsDetailStore

    const navigate = useNavigate()

    return <Page
        breadcrumb={[
            {
                link: '/cms',
                label: `Kundenverwaltung`
            },
            {
                link: `/cms/${cmsDetailStore.id}`,
                label: `${name} (${customerNumber})`
            }
        ]}
    >
        <PageContentTitle>
            <div style={{display: "flex"}}>
                <div style={{paddingRight: '1em'}}>
                    <button className={`button is-rounded is-small is-info ${!tab ? '' : 'is-outlined'}`}
                            onClick={() => {
                                navigate(`/cms/${cmsDetailStore.id}`)
                            }}>Kundendaten
                    </button>
                </div>
                <div style={{paddingRight: '1em'}}>
                    <button className={`button is-rounded is-small is-info 
                        ${tab === 'scan-document-rules' ? '' : 'is-outlined'}`}
                            onClick={() => {
                                navigate(`/cms/${cmsDetailStore.id}/scan-document-rule`)
                            }}>Scan Dokumenten Regeln
                    </button>
                </div>
                <div style={{paddingRight: '1em'}}>
                    <button className={`button is-rounded is-small is-info 
                        ${tab === 'configuration' ? '' : 'is-outlined'}`}
                            onClick={() => {
                                navigate(`/cms/${cmsDetailStore.id}/configuration`)
                            }}>Konfiguration
                    </button>
                </div>
            </div>
        </PageContentTitle>
        {!tab && <CmsCustomerDetail/>}
        {tab === 'configuration' && <CmsConfigurationPage/>}
        {tab === 'scan-document-rules' && <CmsRulesOverviewPage/>}
        {tab === 'scan-document-rule-detail' && <CmsRuleDetailPage/>}
        {tab === 'scan-document-rule-create' && <CmsRuleCreatePage/>}
    </Page>
})

export {
    CmsDetailPage
}
